export const MEDIA_SIZES = {
    MOBILE: 320,
    MOBILE_LARGE: 640,
    TABLET: 768,
    TABLET_LARGE: 1024,
    TABLET_EXTRA_LARGE: 1367,
    DESKTOP: 1440,
    DESKTOP_LARGE: 1680
  };
  
  export const MEDIA_TYPES = {
    MOBILE: 'mobile',
    MOBILE_LARGE: 'mobile-large',
    TABLET: 'tablet',
    TABLET_LARGE: 'tablet-large',
    TABLET_EXTRA_LARGE: 'tablet-extra-large',
    DESKTOP: 'desktop',
    DESKTOP_LARGE: 'desktop-large'
  };
  